export default {
  'address': 'Address',
  'auth': {
    'connected': 'Connected',
    'connectionSettings': 'Connection settings',
    'connectionSettingsSubtitle': 'Define the application server parameters',
    'dbName': 'Database name',
    'deviceName': 'Device name',
    'email': 'E-mail',
    'expiredSession': 'Session expired. Please log in again.',
    'forgotPassword': 'Forgot my password',
    'forgotPasswordAction': 'Send',
    'forgotPasswordSubtitle': 'Password will be reset. We will send you a confirmation email.',
    'forgotPasswordTitle': 'Forgot your password?',
    'language': 'language',
    'languageSelect': 'Select a language',
    'login': 'Log in',
    'logoutPrompt': 'Are you sure you want to logout?',
    'notConnected': 'You are not connected',
    'notConnectedSubtitle': 'Set up your connection',
    'offline': 'offline',
    'offlineLogin': 'Offline login',
    'online': 'online',
    'password': 'password',
    'rememberMe': 'Remember me',
    'resetPassword': 'Reset Password',
    'saveSettings': 'Save settings',
    'serverIP': 'Server IP',
    'serverPort': 'Server Port',
    'subtitle': "Let's get to work",
    'username': 'username',
    'userType': 'UserType',
    'version': 'Version',
    'welcome': 'Welcome',
  },
  'baseObject': {
    'actions': 'Actions',
    'boid': 'BOID',
    'code': 'Code',
    'createUser': 'Created By',
    'createdDate': 'Created Date',
    'deleted': 'Deleted',
    'exportDate': 'Export date',
    'isActive': 'Active',
    'isFromManager': 'From Manager',
    'lastUpdate': 'Last Update',
    'name': 'Name',
    'rowStatus': 'Row Status',
    'sequence': 'Sequence',
    'updateUser': 'Updated By',
  },
  'branch': 'Branch',
  'city': 'City',
  'common': {
    'actions': {
      'add': 'Add',
      'addAll': 'Add All',
      'addFiltered': 'Add Filtered',
      'addNew': 'Add new',
      'allowed': 'Allowed',
      'cancel': 'Cancel',
      'clear': 'Clear',
      'clone': 'Clone',
      'close': 'Close',
      'closepopup': 'Close popup',
      'confirm': 'Confirm',
      'create': 'Create',
      'defineSet': 'Define set',
      'delete': 'Delete',
      'deleteAll': 'Delete All',
      'edit': 'Edit',
      'moveTo': 'Move to',
      'no': 'No',
      'notAllowed': 'Not allowed',
      'restore': 'Restore',
      'save': 'Save',
      'search': 'Search',
      'select': 'Select',
      'showLess': 'Show less',
      'showMore': 'Show more',
      'view': 'View',
      'yes': 'Yes',
    },
    'definedSets': 'Defined Sets',
    'defineSets': 'Define Set',
    'defineSetsMustAtLeast': 'Define your sets and the materials/groups that "Must" or "At least"',
    'invalid': 'Invalid',
    'materialsGroups': 'Materials/Groups',
    'must': 'Must',
    'next': 'Next',
    'or': 'or',
    'other': 'Other',
    'previous': 'Previous',
    'setSameAs': 'Set: Same as',
    'table': {
      'applyFilters': 'Apply Filters',
      'resetFilters': 'Reset All',
      'selected': 'Selected',
    },
    'tableGroup': 'Drag a column here to group by that column',
    'toast': {
      'closepopup': 'Close popup',
      'error': 'Error',
      'info': 'Information',
      'success': 'Success',
      'warning': 'Warning',
    },
    'tooltip': {
      'cardView': 'Card',
      'columnOrder': 'Move columns',
      'download': 'Download',
      'enhancedView': 'Details',
      'filterMaterialsByGroup': 'Filter materials by group',
      'horizontalLayout': 'Landscape',
      'print': 'Print',
      'refresh': 'Refresh',
      'report': 'Report',
      'saveLayout': 'Save layout',
      'sendEmail': 'Send Email',
      'showFilter': 'Filter',
      'tableView': 'Table',
      'verticalLayout': 'Portrait',
    },
    'totalRecords': 'Total Records',
    'valid': 'Valid',
  },
  'competitor': {
    'competitorType': 'Competitor Type',
    'profession': 'Profession',
    'properties': 'Properties',
    'remarks': 'Remarks',
    'trader': 'Trader',
    'traderAddress': 'Trader Address',
    'traderCity': 'Trader City',
    'traderCode': 'Trader Code',
    'traderName': 'Trader Name',
    'traderTaxNumber': 'Trader Tax Number',
    'traderZipCode': 'Trader ZIP Code',
  },
  'competitorMaterials': {
    'competitorMaterial': "Competitor's material",
    'match': 'Match Materials',
    'selectCompetitor': 'Select a competitor',
    'selectMaterial': 'Select your material',
  },
  'customer': {
    'currentTraderSiteAddress': 'Trader Site Address',
    'currentTraderSiteTaxCode': 'Trader Site Taxcode',
    'defaultDocumentType': 'Default Document type',
    'defaultPaymentType': 'Default Payment Type',
    'defaultTraderSite': 'Default Trader Site',
    'discountPercentage': 'Discount Percentage (%)',
    'financialInfo': 'Financial Info',
    'minOrder': 'Minimum Order',
    'paymentDays': 'Payment Days',
    'plafond': 'Plafond',
    'profession': 'Profession',
    'properties': 'Properties',
    'ranges': 'Ranges',
    'trader': 'Trader',
    'traderAddress': 'Trader Address',
    'traderCity': 'Trader City',
    'traderCode': 'Trader Code',
    'traderJob': 'Trader Profession',
    'traderName': 'Trader Name',
    'traderSiteAddress': 'Trader Site Address',
    'traderSiteCity': 'Trader Site City',
    'traderSiteCode': 'Trader Site Code',
    'traderSiteIsHQ': 'Trader Site Is HQ',
    'traderSiteName': 'Trader Site Name',
    'traderSites': 'Tradersites',
    'traderSiteZipCode': 'Trader Site Zip Code',
    'traderTaxNumber': 'Trader Tax Number',
    'traderTitle': 'Title',
    'traderZipCode': 'Trader Zip Code',
  },
  'date': {
    'date': 'date',
    'days': {
      '0': 'Sunday',
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
      '6': 'Saturday',
    },
    'invalidDate': 'Invalid Date',
    'months': {
      '0': 'January',
      '1': 'February',
      '2': 'March',
      '3': 'April',
      '4': 'May',
      '5': 'June',
      '6': 'July',
      '7': 'August',
      '8': 'September',
      '9': 'October',
      '10': 'November',
      '11': 'December',
    },
    'now': 'now',
    'time': 'time',
    'today': 'today',
  },
  'device': {
    'device': 'Device',
    'lastLogin': 'Last Login',
    'loadItemLines': 'Load Item Lines',
    'remarks': 'Remarks',
  },
  'device-configuration': {
    'companySite': 'Company Site',
    'defaultUser': 'Default User',
    'documentSeries': 'Document Series',
    'documentType': 'Document Type',
    'functionality': 'Functionality',
  },
  'discountMatrix': {
    'discount': 'Discount %',
    'discountType': 'Discount Type',
    'materialGroup': 'Material group',
    'traderSite': 'Trader site',
    'traderSiteGroup': 'Trader site group',
    'value': 'Value €',
  },
  'distribution-channel': {
    'company': 'Company',
    'exvan': 'Exvan',
    'isDefault': 'Is Default',
    'logistics': 'Logistics',
    'orders': 'Orders',
    'uniqueTradersPerRoute': 'Unique Traders Per Route',
  },
  'documentDetails': {
    'discount1': 'Discount 1',
    'discount2': 'Discount 2',
    'discount3': 'Discount 3',
    'discount4': 'Discount 4',
    'discount5': 'Discount 5',
    'discount6': 'Discount 6',
    'grossValue': 'Gross Value',
    'materialCode': 'Material Code',
    'materialName': 'Material Name',
    'netValue': 'Net Value',
    'quantity1': 'Quantity 1',
    'quantity2': 'Quantity 2',
    'quantity3': 'Quantity 3',
    'rowId': 'Row ID',
    'totalDiscount': 'Total Discount',
    'unit1': 'Unit 1',
    'unit2': 'Unit 2',
    'unit3': 'Unit 3',
    'unitPrice': 'Unit Price',
    'vatPercent': 'VAT %',
    'vatValue': 'VAT Value',
  },
  'document-type': {
    'allowDynamicRange': 'Allow Dynamic Range',
    'allowEditClosedDocuments': 'Edit Closed Documents',
    'allowHeaderDiscounts': 'Allow Header Discounts',
    'allowManualPrices': 'Allow Manual Prices',
    'allowZeroQty': 'Allow Zero Quantity',
    'allowZeroValues': 'Allow Zero Values',
    'caption': 'Caption',
    'columnDefinitions': 'Column Definitions',
    'common': 'Common',
    'company': 'Company',
    'configurationProperties': 'Configuration',
    'daysToDelivery': 'Delivery After Number Of Days',
    'defaultDeliveryType': 'Default Delivery Type',
    'defaultDocumentStatus': 'Default Document Status',
    'defaultPaymentType': 'Default Payment Type',
    'defaultTrader': 'Default Trader',
    'defaultWarehouse': 'Default Warehouse',
    'description': 'Description',
    'division': 'Division',
    'documentSeries': 'Document Series',
    'fields': 'Fields',
    'maxDetailQty': 'Max Detail Quantity',
    'maxDetailUnitPrice': 'Max Detail Unit Price',
    'mergedSameDocumentLines': 'Merged Same Document Lines',
    'order': 'Order',
    'parentDocumentType': 'Parent Document Type',
    'previewColumns': 'Preview Columns',
    'previewDescription':
      'This preview shows how the columns will appear in the sales document details table based on your configuration.',
    'previewNote': 'Preview Information:',
    'previewNoteColumns': 'Columns are displayed according to the JSON configuration',
    'previewNoteWidth': 'Column widths match the defined values',
    'previewNoteOrder': 'Column order follows the OrderNumber property',
    'properties': 'Properties',
    'relatedDocumentTypes': 'Related Document Types',
    'reportingTemplate': 'Reporting Template',
    'remove': 'Remove',
    'requireDeliveryType': 'Require Delivery Type',
    'requirePaymentType': 'Require Payment Type',
    'requireWarehouse': 'Require Warehouse',
    'sequenceFormat': 'Sequence Format',
    'specific': 'Specific',
    'supportLoyalty': 'Support Loyalty',
    'syncWithMyData': 'Sync with myData',
    'takeDigitalSignature': 'Take Digital Signature',
    'totalMeasurementUnits': 'Total Measurement Units',
    'trader': 'Trader',
    'usePaymentTypes': 'Use Payment Types',
    'width': 'Width',
  },
  'groups': {
    'accountGroup': 'Account Group',
    'active': 'Active',
    'addGroup': 'Add Group',
    'addGroupItem': 'Add {item}',
    'alterCode': 'Alter Code',
    'description': 'Description',
    'groups': 'Groups',
    'maxLevel': 'Max Level',
    'name': 'Name',
    'system': 'System',
  },
  'HQ': 'HQ',
  'imageUpload': 'Drag and drop an image here, or click to select',
  'material': {
    'active': 'Active',
    'alterCode': 'Alter Code',
    'alterCodeType': 'Alter Code Type',
    'alterName': 'Alternative Name',
    'allowManualPrice': 'Allow manual price',
    'allowZeroValue': 'Allow zero price',
    'boid': 'Boid',
    'code': 'Code',
    'color': 'Color',
    'company': 'Company Name',
    'companyAlterCodes': 'Company Materials Alter Codes',
    'competitor': 'Competitor',
    'competitorAlterCodes': 'Competitor Materials Alter Codes',
    'createUser': 'Created By',
    'createdDate': 'Created Date',
    'default': 'Default',
    'dimension': 'Dimension {number}',
    'dimensions': 'Dimensions',
    'hasMixInfo': 'Mix Information',
    'inactive': 'Inactive',
    'isActive': 'Status',
    'isFromManager': 'From Manager',
    'lastUpdate': 'Last Update',
    'lotFinish': 'Lot Finish',
    'lotStart': 'Lot Start',
    'material': 'Material',
    'materialDC': 'Material Distribution Channel',
    'materialType': 'Material Type',
    'materials': 'Materials',
    'measurementUnit': 'Measurement Unit',
    'minSalesQuantity': 'Min Sales Quantity',
    'mwAccountGroup': 'Account Group',
    'name': 'Name',
    'quantityTotalizer': 'Quantity Totalizer',
    'relationFactor': 'Relation Factor',
    'remarks': 'Remarks',
    'rowStatus': 'Row Status',
    'securityStock': 'Security Stock',
    'sequence': 'Sequence',
    'size': 'Size',
    'smallCode': 'Short Code',
    'smallName': 'Short Name',
    'style': 'Style',
    'unit1': 'Unit 1',
    'unit2': 'Unit 2',
    'unit3': 'Unit 3',
    'updateUser': 'Updated By',
    'vatCategory': 'VAT category %',
  },
  'messages': {
    'continueEdit': 'Continue Editing',
    'dismissChanges': 'Discard Changes',
    'errors': {
      'aadeError': 'An error occurred while sending the document to AADE.',
      'access': 'Missing required permissions to access this route',
      'cannotDelete': 'Records cannot be deleted.',
      'columnDefinitionsJsonError': 'Failed to parse column definitions for preview',
      'customerReferencedByTraderSite':
        'Customer cannot be deleted because it is referenced by a trader site.',
      'dateError': 'Date Selection Error',
      'duplicateRemoteCode': 'This remote code already exists for this representative',
      'emptyNode': 'Can not create empty node.',
      'failedToCloneQuestionnaire': 'Failed to clone questionnaire.',
      'failedToLoadQuestionnaire': 'Failed to load questionnaire data.',
      'fileTypeNotAllowed': 'This file type is not supported. Please upload an image.',
      'greaterThan0': 'Greater than 0',
      'integer': 'Please enter an integer value.',
      'invalidDateFormat': 'Invalid date format',
      'invalidEmail': 'Invalid email address',
      'invalidNodeMove': 'A node cannot be placed within its own hierarchy',
      'invalidValue': 'Invalid value',
      'largeFile': 'This file exceeds the 1MB limit.',
      'materialNotInActiveCatalog': 'Material does not exist on an active price catalog',
      'maxGraterThanMin': 'Max value must be greater Minimum value',
      'maxValue': 'Max value',
      'minSmallerThanMax': 'Minimum value must be smaller than Maximum value',
      'minValue': 'Min value',
      'missingFinancialInfo': 'Financial info not found',
      'missingMaterialRecentTransactions': 'No transactions found.',
      'noDefaultReportingTemplate': 'Reporting Template is not assinged',
      'nonNegative': 'Value must be at least 0',
      'required': 'Required',
      'requiredField': 'The field is required',
      'salesDocumentHeaderIncomplete':
        'Please fill the required fields before adding document lines.',
      'selectTraderSiteFirst': 'Please select a trader site first and try again',
      'sequenceMustBeUnique': 'Sequence must be unique',
      'somethingWentWrong': 'Something went wrong',
      'totalMeasurementUnitsRange': 'Total measurement units must be 1, 2, or 3',
    },
    'info': {
      'addDataTableText': 'Add a new record here',
      'ctrlClickToAddItems': 'Ctrl + click to add items',
      'deleteAdded':
        'Are you sure you want to delete {item}? The new, unsaved items, cannot be restored when deleted.',
      'deleteCascade':
        'Are you sure you want to delete the selected records? This may delete records that depend on them.',
      'deleteModified':
        'Are you sure you want to delete {item}? The modified, unsaved items, lose all their changes.',
      'deleteNode':
        'Are you sure you want to delete the selected node? All of its child nodes will also be deleted.',
      'deleteRecords': 'Are you sure you want to delete the selected records?',
      'deleteSingle': 'Are you sure you want to delete {item}?',
      'deleteAllItems': 'Are you sure you want to delete all items?',
      'emptyTableText': 'No data available',
      'restoreSingle': 'Are you sure you want to restore {item}?',
      'selectedItemsCannotBeDeleted': 'Selected items cannot be deleted.',
      'selectedItemsCannotBeEdited': 'Selected items cannot be edited.',
    },
    'noResultsFor': "No results found for '{query}'",
    'noResultsText': 'No Results',
    'noUpdateDeleted': 'You cannot update deleted item',
    'saveLineChangesPrompt': 'Make sure to save the line changes before saving the document',
    'success': {
      'deletedSuccessfully': 'Deleted successfully.',
      'resetPassword': 'Password was reset.',
      'successfullyDeleted': 'Successfully deleted.',
    },
    'unsavedChanges':
      'You have unsaved changes. Would you like to continue editing or discard these changes?',
  },
  'missedVisitReasons': {
    'dueToPlan': 'Due to plan',
    'dueToSalesperson': 'Due to salesperson',
    'dueToTraderSite': 'Due to trader site',
    'missedVisitReason': 'missed visit reason',
  },
  'myDataDocuments': {
    'division': 'Division',
    'documentNumber': 'Number',
    'documentSeries': 'Series',
    'documentType': 'Type',
    'errorDetails': 'Error Details',
    'filters': {
      'byDocumentSeries': 'By Document Series',
      'byDocumentType': 'By Document Type',
      'byDivision': 'By Division',
      'bySyncStatus': 'By Sync Status',
      'dateFrom': 'Date From',
      'dateTo': 'Date To',
      'syncFailed': 'Failed',
      'syncSuccess': 'Synced',
      'syncUnsynced': 'Unsynced',
    },
    'myDataMark': 'MyData Mark',
    'myDataQrCode': 'MyData QR Code',
    'myDataUuid': 'MyData UUID',
    'noErrorMessage': 'No error message available',
    'propertiesDetails': 'MyData Properties',
    'syncFailed': 'Failed',
    'syncStatus': 'Status',
    'syncSuccess': 'Synced',
    'syncUnsynced': 'Unsynced',
    'title': 'myData Documents',
    'totalGross': 'Total Gross',
    'totalQuantity': 'Total Quantity',
    'trader': 'Trader',
    'traderSite': 'Trader Site',
    'uploadSelected': 'Upload to myData',
  },
  'mw-params': {
    'company': 'Company',
    'remarks': 'Remarks',
    'value': 'Value',
  },
  'pages': {
    'alter-code-types': 'Alter Code Types',
    'alter-codes': 'Alter Codes',
    'app-preferences': 'App Preferences',
    'assortment-details': 'Assortments Management',
    'assortments-management': 'Assortments Management',
    'competitor-materials': 'Competitor Materials',
    'competitor-materials-wizard': 'Competitor Materials',
    'competitor-types': 'Competitor Types',
    'competitors': 'Competitors',
    'competitors-preview': 'Competitors',
    'customers': 'Customers',
    'customers-preview': 'Customers',
    'dashboard': 'Home',
    'delivery-types': 'Delivery Types',
    'device-details': 'Devices',
    'devices': 'Devices',
    'distribution-channels': 'Distribution Channels',
    'distribution-channels-details': 'Distribution Channels',
    'divisions': 'Divisions',
    'document-series': 'Document Series',
    'document-series-details': 'Document Series - Details',
    'document-statuses': 'Document Statuses',
    'document-types': 'Document Types',
    'document-types-details': 'Document Types',
    'documents-management': 'Documents Management',
    'documents-management-details': 'Documents Management - Details',
    'dynamic-ranges': 'Dynamic Ranges',
    'grouping': 'Grouping',
    'installation': 'Installation',
    'materials': 'Materials',
    'materials-management': 'Materials Management',
    'materials-management-preview': 'Materials Management',
    'missed-visits-reasons': 'Missed Visits Reasons',
    'myAccount': 'My account',
    'mydata': 'myData Documents',
    'payment-types': 'Payment Types',
    'price-catalog-details': 'Price Catalog Details',
    'price-catalogs': 'Price Catalogs',
    'price-collection-last-visit-values': 'Price Collection - Last Visit Values',
    'price-policies': 'Price Policies',
    'price-policies-matrix-details': 'Pricing policy',
    'qst-actions': 'Actions',
    'questionnaires-management': 'Questionnaires Management',
    'questionnaires-management-details': 'Questionnaires Management Details',
    'questionnaires-report': 'Answers Per Visit',
    'questionnaires-report-details': "Visit's Answers",
    'questions-details': 'Questions Details',
    'ranges-details': 'Range Details',
    'ranges-management': 'Ranges',
    'report-pricing': 'Report Pricing',
    'reporting': 'Reporting',
    'reporting-designer': 'Reporting Designer',
    'representatives': 'Representatives management',
    'representatives-details': 'Representative Details',
    'representatives-transactions': 'Representative Transactions',
    'representatives-transactions-details': 'Transaction Details',
    'role-details': 'Role Details',
    'roles': 'Roles Management',
    'route-definitions': 'Route Definitions',
    'route-details': 'Route Trader Sites',
    'route-week-plan': 'Route Week Plan',
    'routes-management': 'Routes Management',
    'sales-areas': 'Sales areas',
    'sales-documents': 'Sales Documents',
    'sales-documents-details': 'Sales Document Details',
    'salespersons-hierarchy': 'Salespersons hierarchy',
    'salespersons-management': 'Salespersons management',
    'salespersons-management-details': 'Salesperson management',
    'salespersons-types': 'Salespersons types',
    'settings': 'Settings',
    'trader-sites': 'Trader Sites',
    'trader-sites-preview': 'Trader Sites',
    'traders': 'Traders',
    'traders-preview': 'Trader',
    'user-defined-reports': 'User Defined Reports',
    'user-details': 'User Details',
    'users': 'Users Management',
    'validation-logger': 'Validation Logger',
    'vat-categories': 'VAT Categories',
    'vat-factors': 'VAT Factors',
    'vat-levels': 'VAT Levels',
    'visit-plans': 'Visit Plans',
    'warehouses-management': 'Warehouses management',
  },
  'price-collection-document': {
    'documentNumber': 'Document Header Number',
    'isCompetitorPriceCollection': 'Is Competitor Price Collection',
    'salesPerson': 'Sales Person',
    'salesPersonCode': 'Sales Person Code',
    'sendDate': 'Send Date',
    'traderSite': 'Trader Site',
  },
  'price-catalog': {
    'addAllCustomers':
      'All customers will be added, and any changes in the form will be saved. Are you sure you want to continue?',
    'addAllModalSubText': 'The form will be saved automatically. Are you sure you want to proceed?',
    'addAllModalText': 'You are about to add all materials with the following values',
    'catalogsList': 'Catalogs list',
    'endDate': 'End Date',
    'includeVat': 'Include VAT',
    'permitDiscount': 'Permit Discount',
    'startDate': 'Start Date',
  },
  'pricing': {
    'pricingPolicy': 'Pricing policy',
    'pricingType': 'Pricing type',
  },
  'pricing-catalogs': {
    'addNewCatalogPolicyTitle': 'Add new catalog policy',
    'addNewCatalogTitle': 'Add catalogs',
    'catalog': 'Catalog',
    'categories': 'Categories',
    'company': 'Company',
    'discountMatrix': 'Discount Matrix',
    'editCatalogPolicyTitle': 'Edit catalog policy',
    'maxDiscount': 'Max discount %',
    'maxDiscountValue': 'Max discount val',
    'orderPolicies': 'Order Policies',
    'price': 'Price €',
    'priceCatalogs': 'Price Catalogs',
    'previousPrice': 'Previous price €',
    'selectCategory': 'Select Category',
    'status': 'Status',
  },
  'prototypes': {
    'acceptedValue': 'Accepted Value',
    'condition': 'Condition',
    'perfectValue': 'Perfect Value',
    'products': 'Products',
    'recommendedValue': 'Recommended Value',
  },
  'qst-actions': {
    'actionDetail': 'Action Details',
    'addAction': 'Add Actions',
    'addActionDetail': 'Add Action Detail',
    'description': 'Description',
    'editAction': 'Edit Actions',
    'editActionDetail': 'Edit Action Detail',
    'qstActionUpdated': 'QST Action Updated',
    'settled': 'Settled',
  },
  'qst-transaction-master': {
    'userName': 'Username',
    'visitDateFrom': 'Visit Date From',
    'visitDateTo': 'Visit Date To',
  },
  'question': {
    'answerValue': 'Answer Value',
    'dataType': 'Data type',
    'halo': 'Maximum value limit',
    'image': 'Image',
    'lalo': 'Minimum value limit',
    'lastVisitData': 'Last visit data',
    'listValues': 'List values',
    'nullValues': 'Null values',
    'preview': 'Preview',
    'sort': 'Sort',
  },
  'questionnaire': {
    'action': 'Action',
    'assortment': 'Assortment',
    'bindingType': 'Binding Type',
    'deleteQuestionnaires':
      'Are you sure you want to delete the selected questionnaires? All of its questions will also be deleted.',
    'deleteQuestionnaireWarning': 'All of its questions will also be deleted.',
    'description': 'Description',
    'effectiveFrom': 'Effective from',
    'effectiveUpTo': 'Effective up to',
    'groupItem': 'Materials group',
    'isStandards': 'Standards',
    'listColumns': 'No. Columns',
    'partialCloneError': 'Questionnaire cloned but some questions or prototypes were not saved.',
    'preview': 'Questionnaire Preview',
    'prototypes': 'prototypes',
    'questionnaireClonedSuccessfully': 'Questionnaire cloned successfully!',
    'questionnaireTitle': 'Questionnaire Title',
    'questionnaireType': 'Type',
    'questions': 'questions',
    'questionsApplication': 'Questions Application',
    'questionTitle': 'Question Title',
    'saveBeforeNavigating': 'Please save the questionnaire first to avoid losing your changes.',
    'title': 'Title',
    'traderSiteGroup': 'Trader site group',
  },
  'ranges': {
    'alterCodeCode': 'Alternative Code',
    'alterCodeName': 'Alternative Name',
    'code': 'Range code',
    'customerCode': 'Customer code',
    'editDynamicRange': 'Edit Dynamic Range Item',
    'hasDynamicRange': 'Dynamic range',
    'lastDocumentDate': 'Ημ/νία Παραστατικού',
    'materialCode': 'Material Code',
    'materialName': 'Matrerial Name',
    'name': 'Range name',
    'quantity': 'Quantity',
    'traderName': 'Όνομα Πελάτη',
    'traderSite': 'Trader site',
    'traderSiteCode': 'Trader site code',
    'traderSiteName': 'Όνομα Διεύθυνσης Υποκαταστήματος',
  },
  'reporting': {
    'datasourceScript': 'Datasource Script',
    'documentType': 'Document type',
    'functionality': 'Functionality',
    'multipleParams':
      'Multiple different $$ parameters found. Please use exactly one $$ parameter.',
    'template': 'Template',
    'unsafeSql': 'Unsafe SQL',
  },
  'representative': {
    'addImport': 'Add Import',
    'allowChange': 'Allow Change',
    'allowUpdate': 'Allow Update',
    'approvalUser': 'Approval User',
    'company': 'Company',
    'companyDocumentType': 'Company Document Type',
    'companyInfo': 'Company',
    'companyPaymentType': 'Company Payment Type',
    'companySite': 'Company Site',
    'companyWarehouse': 'Company Warehouse',
    'confirmSetAsDefaultForAllCustomers':
      'Are you sure you want to set this document type as the default for all customers?',
    'customer': 'Customer',
    'customerCode': 'Customer Code',
    'customerRemotedAddress': 'Remote Customer Address',
    'customerRemotedCity': 'Remote Customer City',
    'customerRemotedCode': 'Remote Customer Code',
    'customerRemotedName': 'Remote Customer Name',
    'customerRemotedTaxCode': 'Remote Customer Tax Code',
    'customers': 'Customers',
    'customerSiteAddress': 'Customer Site Address',
    'customerSiteCity': 'Customer Site City',
    'customerSiteCode': 'Customer Site Code',
    'customerSiteName': 'Customer Site Name',
    'defaultDocumentTypeSetSuccessfully':
      'Default document type has been set successfully for all customers.',
    'dbName': 'Database Name',
    'dbUsername': 'Database Username',
    'dbPassword': 'Database Password',
    'document': 'Document',
    'documentDescription': 'Document Description',
    'documentHeaderRowId': 'Document Header Row ID',
    'documentNumber': 'Document Number',
    'documentSeriesRemotedCode': 'Document Series Remoted Code',
    'documentType': 'Document Type',
    'documentTypeCode': 'Document Type Code',
    'documentTypeRemotedCode': 'Document Type Remoted Code',
    'documentTypes': 'Document Types',
    'editImport': 'Edit Import',
    'entities': {
      'customer': 'Customer',
      'documentType': 'Document Type',
      'materialAlterCode': 'Material Alternative Code',
      'measurementUnit': 'Measurement Unit',
      'paymentType': 'Payment Type',
      'representativeImport': 'Representative Import',
      'traderSite': 'Trader Site',
      'warehouse': 'Warehouse',
    },
    'erpName': 'ERP Name',
    'exportFileNameFormat': 'Export File Name Format',
    'exportMethodType': 'Export Type',
    'exportFolder': 'Export Folder',
    'exportUrl': 'Export URL',
    'fieldMapping': {
      'addFieldMapping': 'Add Field Mapping',
      'cacheResults': 'Cache Results',
      'cacheTimeout': 'Cache Timeout',
      'childFieldMappings': 'Child Field Mappings',
      'childMappingSettings': 'Child Mapping Settings',
      'childRecordType': 'Child Record Type',
      'dataType': 'Data Type',
      'defaultValue': 'Default Value',
      'description': 'Description',
      'editFieldMapping': 'Edit Field Mapping',
      'isChildCollection': 'Is Child Collection',
      'isNullable': 'Is Nullable',
      'isRequired': 'Is Required',
      'keyField': 'Key Field',
      'lookupDescription': 'Lookup Description',
      'lookupEnabled': 'Lookup Enabled',
      'lookupTable': 'Lookup Table',
      'resultField': 'Result Field',
      'sourceField': 'Source Field',
      'targetField': 'Target Field',
      'toValidateEnabled': 'To_Validate Enabled',
      'toValidateLogTableName': 'To_Validate Log Table Name',
      'toValidateSourceField': 'To_Validate Source Field',
      // MappingField properties
      'csvColumnIndex': 'CSV Column Index',
      'csvColumnName': 'CSV Column Name',
      'databaseColumnName': 'Database Column Name',
      'fixedLengthLength': 'Length',
      'fixedLengthStartPosition': 'Start Position',
      'jsonPath': 'JSON Path',
      // ChildMappingSettings properties
      'childCsvDetailSeparator': 'Child CSV Detail Separator',
      'childCsvFieldSeparator': 'Child CSV Field Separator',
      'childCsvStartColumnIndex': 'Child CSV Start Column Index',
      'childDatabaseGroupBy': 'Group By',
      'childDatabaseJoinCondition': 'Join Condition',
      'childFixedLengthDetailRecordLength': 'Child Fixed Length Detail Record Length',
      'childFixedLengthMaxDetails': 'Child Fixed Length Max Details',
      'childFixedLengthStartPosition': 'Child Fixed Length Start Position',
      'childJsonArrayPath': 'Child JSON Array Path',
      'childJsonItemPath': 'Child JSON Item Path',
      'childRelationshipKey': 'Child Relationship Key',
      'childToKeyField': 'Child To Table Key Field',
      'childToTableName': 'Child To Table Name',
      'errors': {
        'parentMappingRequired':
          'You must first create a field mapping for "{parentProperty}" as a child collection before adding child properties.',
      },
      // FilterCondition properties
      'addNew': 'Add Field Mapping',
      'field': 'Field',
      'filterConditions': 'Filter Conditions',
      'operator': 'Operator',
      'rowMapping': 'Row Mappings',
      'value': 'Value',
    },
    'importFileNameFormat': 'Import File Type',
    'importFolder': 'Import Folder',
    'importUrl': 'Import URL',
    'isApproved': 'Is Approved',
    'isInvalid': 'Invalid',
    'isMapped': 'Mapped',
    'lastExportedDate': 'Last Exported Date',
    'lastImportDate': 'Last Import Date',
    'mapping': 'Mapping',
    'materialAlterCodes': 'Material Alter Codes',
    'measurementUnits': 'Measurement Units',
    'officialDate': 'Official Date',
    'paymentTypeCode': 'Payment Type Code',
    'paymentTypeRemotedCode': 'Payment Type Remoted Code',
    'paymentTypes': 'Payment Types',
    'properties': 'Properties',
    'recipient': 'Recipient',
    'recipientAddress': 'Recipient Address',
    'recipientCity': 'Recipient City',
    'recipientCode': 'Recipient Code',
    'recipientName': 'Recipient Name',
    'recipientRemotedAddress': 'Remote Recipient Address',
    'recipientRemotedCity': 'Remote Recipient City',
    'recipientRemotedCode': 'Remote Recipient Code',
    'recipientRemotedName': 'Remote Recipient Name',
    'recipientRemotedTaxCode': 'Remote Recipient Tax Code',
    'recipientSiteAddress': 'Recipient Site Address',
    'recipientSiteCity': 'Recipient Site City',
    'recipientSiteCode': 'Recipient Site Code',
    'recipientSiteName': 'Recipient Site Name',
    'recipientTaxCode': 'Recipient Tax Code',
    'recordMapping': {
      'addNew': 'Add Type Mapping',
      'allowCustomSeparators': 'Allow Custom Separators',
      'arrayPath': 'Array Path',
      'commandTimeout': 'Command Timeout',
      'concatenationDescription': 'Concatenation Description',
      'concatenationSettings': 'Concatenation Settings',
      'connectionString': 'Connection String',
      'createdDate': 'Created Date',
      'defaultSeparator': 'Default Separator',
      'description': 'Description',
      'editRecordMapping': 'Edit Record Mapping',
      'encoding': 'Encoding',
      'importSettings': 'Import Settings',
      'includeSeparatorInSource': 'Include Separator In Source',
      'mappingInfo': 'Mapping Info',
      'mappingType': 'Mapping Type',
      'mappings': 'Mappings',
      'padCharacter': 'Pad Character',
      'query': 'Query',
      'quoteCharacter': 'Quote Character',
      'recordLength': 'Record Length',
      'recordType': 'Record Type',
      'representative': 'Representative',
      'rootPath': 'Root Path',
      'selectRecordMappingToViewFields': 'Select Record Mapping To View Fields',
      'separator': 'Separator',
      'setAsDefaultForAllCustomers': 'Set as Default for All Customers',
      'skipFirstLine': 'Skip First Line',
      'targetEntity': 'Target Entity',
      'toApprove': 'To Approve',
      'toExport': 'To Export',
      'traderSite': 'Trader Site',
      'traderSiteRemoteCode': 'Trader Site Remote Code',
      'traderSites': 'Trader Sites',
      'validateSchema': 'Validate Schema',
      'viewRecordMapping': 'View Record Mapping',
    },
    'remarks': 'Remarks',
    'remotedCode': 'Remoted Code',
    'remotedCustomer': 'Remoted Customer',
    'representative': 'Representative',
    'representativeDocumentSeriesCode': 'Document Series Code',
    'representativeDocumentType': 'Document Type',
    'representativeDocumentTypeCode': 'Document Type Code',
    'representativeInfo': 'Representative',
    'representativePaymentType': 'Payment Type',
    'representativeSite': 'Representative Site',
    'selectRepresentative': 'Select Representative',
    'serverAddress': 'Server Address',
    'serverPort': 'Server Port',
    'setAsDefaultForAllCustomers': 'Set as Default for All Customers',
    'source': 'Source',
    'status': 'Status',
    'toApprove': 'To Approve',
    'toExport': 'To Export',
    'traderSite': 'Trader Site',
    'traderSiteRemoteCode': 'Trader Site Remote Code',
    'traderSites': 'Trader Sites',
    'warehouseRemotedCode': 'Warehouse Remoted Code',
    'warehouses': 'Warehouses',
    'windowsAuthentication': 'Windows Authentication',
  },
  'routes': {
    'accountGroup': 'Account group',
    'addTraderSites': 'Add Trader Sites',
    'allowWhenUnique': 'Uniqueness',
    'companySite': 'Company Site',
    'customizeOrderText': 'Customize the order of the visits for every day.',
    'customerCode': 'Customer code',
    'customerProfession': 'Customer profession',
    'definition': 'Route definition',
    'reviewOrderText': 'View the order of the visits for every day.',
    'route': 'Route',
    'routeDefinition': 'Definition',
    'siteCode': 'Site code',
    'typeOfRoute': 'Route type',
    'typeOfSalesPerson': 'Salesperson type',
    'typeOfUser': 'User type',
    'user': 'User',
    'viewWeekPlan': 'View week plan',
  },
  'taxNumber': 'Tax Number',
  'telephone': 'Telephone',
  'trader': {
    'adt': 'Identity Card No.',
    'adtDate': 'Identity Card Date',
    'country': 'Country',
    'county': 'County',
    'doy': 'Doy',
    'firstName': 'First Name',
    'job': 'Job',
    'lastName': 'Last Name',
    'passport': 'Passport',
    'passportExpireDate': 'Passport expire date',
    'socialNumber': 'Social Number',
    'taxOffice': 'Tax Office',
    'title': 'Title',
    'traders': 'traders',
    'vatStatus': 'Vat status',
  },
  'traderSites': {
    'companySite': 'Company site',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'siteName': 'Site name',
    'storePhoto': 'Store photo',
    'traderName': 'Trader name',
  },
  'transactions': {
    'companyAlterCode': 'Company Alter Code',
    'companyUnit2': 'Company Unit 2',
    'companyUnit3': 'Company Unit 3',
    'customerSiteCode': 'Customer Site Code',
    'customerSiteName': 'Customer Site Name',
    'discount1': 'Discount 1',
    'discount2': 'Discount 2',
    'discount3': 'Discount 3',
    'discount4': 'Discount 4',
    'discount5': 'Discount 5',
    'discount6': 'Discount 6',
    'discountValue1': 'Discount Value 1',
    'discountValue2': 'Discount Value 2',
    'discountValue3': 'Discount Value 3',
    'discountValue4': 'Discount Value 4',
    'discountValue5': 'Discount Value 5',
    'discountValue6': 'Discount Value 6',
    'documentNumber': 'Document Number',
    'isFromManager': 'From Manager',
    'officialDate': 'Official Date',
    'remoteCode': 'Remote Code',
    'repMaterialCode': 'Rep Material Code',
    'repMaterialName': 'Rep Material Name',
    'repMeasurementUnit1': 'Rep Measurement Unit 1',
    'repUnit2': 'Rep Unit 2',
    'repUnit3': 'Rep Unit 3',
    'repUnitCode1': 'Rep Unit Code 1',
    'repUnitCode2': 'Rep Unit Code 2',
    'repUnitCode3': 'Rep Unit Code 3',
    'representativeRecipientCode': 'Representative Recipient Code',
    'representativeRecipientName': 'Representative Recipient Name',
    'totalDiscountValue': 'Total Discount Value',
    'vatValue': 'VAT Value',
  },
  'tree': {
    'addChildNode': 'Add child node',
    'addNode': 'Add node',
    'addRoot': 'Add root',
    'deleteItem': 'Delete item',
    'dropIntoRoot': 'Drop Into Root',
    'duplicate': 'Duplicate',
    'edit': 'Edit',
    'fullCollapse': 'Full collapse',
    'fullExpand': 'Full expand',
    'loadMore': 'Load more',
    'rename': 'Rename',
  },
  'salesAreas': {
    'salesArea': 'sales area',
  },
  'salesDocuments': {
    'headers': {
      'billingAddress': 'Billing Address',
      'companySite': 'Company Site',
      'customer': 'Customer',
      'date': 'Issued Date',
      'defaultQuantity': 'Default Quantity',
      'deliveryAddress': 'Delivery Address',
      'deliveryDate': 'Delivery Date',
      'deliveryType': 'Delivery Type',
      'description': 'Description',
      'loadRange': 'Apply Dynamic Range',
      'mediator': 'Mediator',
      'number': 'Number',
      'paymentType': 'Payment Type',
      'salesPerson': 'Sales Person',
      'series': 'Series',
      'status': 'Status',
      'totalCharges': 'Total Charges',
      'totalDiscount': 'Total Discount',
      'totalGross': 'Total Gross',
      'traderSite': 'Customer Site',
      'type': 'Document Type',
      'warehouse': 'Warehouse',
    },
    'filters': {
      'byCustomer': 'By Customer',
      'byCustomerGroup': 'By Customer Group',
      'bySalesPerson': 'By Sales Person',
      'byStatus': 'By Status',
      'byType': 'By Type',
      'dateFrom': 'Date From',
      'dateTo': 'Date To',
    },
    'tabs': {
      'details': 'Details',
      'materials': 'Materials',
      'netTotal': 'Value',
      'remarks': 'Remarks',
      'taxes': 'Taxes',
      'totals': 'Totals',
    },
    'billingAddModalSelect': 'Select Billing Address',
    'chargeValueType': 'Charge Type',
    'chargesTotals': 'Expenses - Charges totals',
    'comments': 'Comments',
    'currentPrice': 'Current Price',
    'customerModalSelect': 'Select Customer',
    'description': 'Description',
    'discountPc': 'Discount %',
    'discountTotal': 'Discount total',
    'discountValue': 'Discount €',
    'documentDiscount': 'Document discount',
    'documentPreview': 'Document Preview',
    'exists': 'In Stock',
    'expensesAndCharges': 'Category',
    'faces': 'Faces',
    'forPrinting': 'For Printing',
    'grossTotal': 'Gross total',
    'grossValue': 'Gross Value',
    'havePromo': 'Have Promo',
    'lastCollectionDate': 'Last Collection Date',
    'lastDate': 'Last Date',
    'lastPrice': 'Last Price',
    'materialBalance': 'Warehouse Stock',
    'mediatorModalSelect': 'Select Mediator',
    'missingDocumentLines': 'Add at least one material to create the document.',
    'missingDocumentSeries': 'No series available. Cannot create document.',
    'netTotal': 'Net total',
    'netTotalAfterDiscounts': 'Net total after discount',
    'netTotalBeforeDiscounts': 'Net total before discount',
    'notExist': 'Not Exist',
    'notExists': 'Out of Stock',
    'qty': 'Qty',
    'quantity': 'Quantity',
    'rangeFail':
      'Dynamic Range could not be applied. Please make sure you have selected Document Type, Customer and Customer Site.',
    'rangeFailDocNotFound': 'Dynamic Range could not be applied. Document not found.',
    'rangeSuccess':
      'There where {linesNumber} new lines added from the Range for Document Type {docType}, Customer {customer} and Address {traderSite}.',
    'recentTransactions': 'Recent transactions',
    'reportPreview': 'Report Preview',
    'saveLinesBeforeChangingSite':
      'Changing the Billing Address can result to re-calculations in document lines. Save all document lines.',
    'search': 'Search by code or description',
    'shelf': 'Shelf',
    'taxesTotal': 'Taxes total',
    'total': 'Total',
    'totalDiscountValue': 'Discount total',
    'totalNetValue': 'Net value total',
    'totalQuantity': 'Total Quantity',
    'totalVat': 'Vat total',
    'traderSiteAddModalSelect': 'Select Customer Site Address',
    'unitDiscount': 'Discount €',
    'unitDiscountPercentage': 'Discount %',
    'unitPrice': 'Unit Price',
    'value': 'Value/Percentage',
    'vat': 'Vat',
    'vatCategory': 'Vat Category',
    'vatFactor': 'Vat factor',
  },
  'salesperson': {
    'addAllModalSubText': 'The form will be saved automatically. Are you sure you want to proceed?',
    'addAllModalText': 'You are about to add all salespersons with the following values',
    'code': 'Code',
    'companySite': 'Company site',
    'distributionCannels': 'Distribution Channels',
    'info': 'Info',
    'maxAccessLevel': 'Max access level',
    'name': 'Name',
    'onlineSearchLevelValue': 'Online search level',
    'salesperson': 'Salesperson',
    'salesPersonDC': 'Salesperson Distribution Channel',
    'salespersonType': 'Sales person type',
    'selectSite': 'Select a site',
    'sequence': 'Sequence',
    'type': 'Type',
    'user': 'User',
    'userName': 'User Name',
    'viewHierarchy': 'View hierarchy',
  },
  'distributionChannel': {
    'distributionChannel': 'Distribution Channel',
  },
  'series': {
    'automaticNumber': 'Automatic number',
    'cancelingSeries': 'Canceling Series',
    'prefix': 'Prefix',
    'sequence': 'Sequence',
    'suffix': 'Suffix',
  },
  'settings': {
    'addModule': 'Add module',
    'adminRoleOverwriteInfo': 'When Administrator Role Selected it will overwrite all other roles.',
    'administrator': 'Administrator',
    'all': 'All',
    'app': 'App',
    'apps': 'Apps',
    'appsModules': 'Apps & modules',
    'appsModulesDesc': 'Activate modules per App',
    'collectionManagement': 'Collection management',
    'companySiteList': 'Company Site',
    'configuration': 'Configuration',
    'desktopAccess': 'Desktop Access',
    'documentsManagement': 'Documents management',
    'general': 'General',
    'generalReporting': 'General Reporting',
    'inStore': 'In store',
    'inventory': 'Inventory',
    'logistics': 'Logistics',
    'managerReporting': 'Manager Reporting',
    'mobileAccess': 'Mobile Access',
    'modules': 'Modules',
    'modulesDesc': 'Activate modules that requires visit.',
    'requiresVisits': 'Requires Visits',
    'roleDetailInfo': 'Manage this role and the permissions per module.',
    'roles': 'Roles',
    'salesSupervision': 'Sales Supervision',
    'transactions': 'Transactions',
    'userDetailInfo': 'Insert users details and define the roles and the sites.',
    'userLastName': 'Full name',
    'workOffline': 'Work Offline',
    'workOfflineDesc': 'Activate Applications that can work offline.',
    'xvan': 'Xvan',
  },
  'sidebar': {
    'documents': 'Documents',
    'favorites': 'Favorites',
    'general': 'General',
    'grouping': 'Grouping',
    'logistics': 'Logistics',
    'menu': 'Menu',
    'priceCollection': 'Price Collection',
    'prices': 'Prices',
    'questionnaires': 'Questionnaires',
    'representatives': 'Representatives',
    'reports': 'Reports',
    'routes': 'Routes',
    'salesDocuments': 'Sales Documents',
    'salesSupervision': 'Sales Supervision',
    'settings': 'Settings',
    'traders': 'Traders',
    'transactions': 'Transactions',
    'warehouse': 'Warehouse',
    'xvan': 'Xvan',
  },
  'validationLogs': {
    'exported': 'Exported',
    'tableName': 'Table Name',
  },
  'vatCategory': 'VAT Category',
  'vatLevel': 'VAT Level',
  'visitPlans': {
    'codeRequired': 'At least one day must be selected',
    'days': 'Days',
    'effectiveWeek': 'Week',
    'executed': 'Executed',
    'giveName': 'Give a name to the visit plan.',
    'insertDays': 'Insert the days you want for the Visit plan.',
    'missed': 'Missed',
    'name': 'Name',
    'planned': 'Planned',
    'remarks': 'Σχόλια',
    'selectAll': 'Select all',
    'visitDate': 'Visit Date',
    'visitPlan': 'Visit plan',
    'visitPlan2': 'visit plan',
    'visitPlans': 'Visit Plans',
    'weeklyStep': 'Weekly step',
  },
  'warehouse': {
    'isLogistics': 'Logistics',
    'minQuantity': 'Min Quantity',
  },
  'zipCode': 'Zipcode',
  'zipCodes': 'Zip Code',
};
